import { render, staticRenderFns } from "./TSGView.vue?vue&type=template&id=16ef11e3&"
import script from "./TSGView.vue?vue&type=script&lang=ts&"
export * from "./TSGView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports